import { esc } from "../lib/escape";

export type PanelHeaderOpts = {
  title: string;
  subtitle?: string;
  backId?: string;
  backLabel?: string;
  headerEndHtml?: string;
};

/** Standard panel header with ← back button. */
export function panelHeaderHtml(opts: PanelHeaderOpts): string {
  const backId = opts.backId || "back-btn";
  const backLabel = opts.backLabel || "Back";
  return `
    <div class="panel-header">
      <div class="panel-header-start">
        <button type="button" class="btn small ghost panel-back" id="${esc(backId)}" aria-label="${esc(backLabel)}">←</button>
        <div class="panel-header-titles">
          <h2>${opts.title}</h2>
          ${opts.subtitle ? `<p class="hint panel-header-sub">${opts.subtitle}</p>` : ""}
        </div>
      </div>
      ${opts.headerEndHtml || ""}
    </div>`;
}

export type FormActionsOpts = {
  saveId?: string;
  saveLabel?: string;
  deleteId?: string;
  deleteLabel?: string;
  showSave?: boolean;
  showDelete?: boolean;
};

/** Standard footer save row for form screens. */
export function formActionsHtml(opts: FormActionsOpts = {}): string {
  const saveId = opts.saveId || "save-btn";
  const saveLabel = opts.saveLabel || "Save";
  const showSave = opts.showSave !== false;
  const showDelete = Boolean(opts.showDelete);
  if (!showSave && !showDelete) return "";
  return `
    <div class="btn-row form-actions">
      ${showSave ? `<button type="button" class="btn primary" id="${esc(saveId)}">${esc(saveLabel)}</button>` : ""}
      ${showDelete ? `<button type="button" class="btn danger" id="${esc(opts.deleteId || "delete-btn")}">${esc(opts.deleteLabel || "Delete")}</button>` : ""}
    </div>`;
}

export type HubBackOpts = {
  backId?: string;
  parentLabel?: string;
};

/** Back button for hub/list sub-screens without a form. */
export function hubBackHtml(opts: HubBackOpts = {}): string {
  const backId = opts.backId || "back-btn";
  return `
    <button type="button" class="btn secondary hub-back" id="${esc(backId)}" aria-label="Back">← Back</button>`;
}

export type DocSuccessActionsOpts = {
  docKind: "invoice" | "quote";
  showCancel: boolean;
  sendLabel: string;
  sendDisabled: boolean;
  hasEmail: boolean;
  referenceHint?: string;
};

/** Action bar for invoice/quote PDF success screens. */
export function docSuccessActionsHtml(opts: DocSuccessActionsOpts): string {
  const cancelLabel = opts.docKind === "invoice" ? "Cancel invoice" : "Cancel quote";
  return `
    <div class="btn-row stacked doc-success-actions">
      <button type="button" class="btn secondary" id="success-download" disabled>Download PDF</button>
      <button type="button" class="btn primary" id="success-send" ${opts.sendDisabled ? "disabled" : ""}>${esc(opts.sendLabel)}</button>
      ${!opts.hasEmail ? `<p class="hint">Add an email to send this ${opts.docKind} automatically.</p>` : ""}
      ${opts.referenceHint || ""}
      ${opts.showCancel ? `<button type="button" class="btn danger" id="success-cancel-doc">${esc(cancelLabel)}</button>` : ""}
      <button type="button" class="btn ghost" id="success-done">Done</button>
    </div>`;
}
